"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./sideSprite.png')],
  frames: [[1432, 2, 473, 1079, 0, -998, -161], [1909, 2, 473, 1079, 0, -998, -161], [2864, 1085, 473, 1079, 0, -998, -161], [956, 1085, 473, 1079, 0, -998, -161], [479, 1085, 473, 1079, 0, -998, -161], [2387, 1085, 473, 1079, 0, -998, -161], [1910, 1085, 473, 1079, 0, -998, -161], [1433, 1085, 473, 1079, 0, -998, -161], [955, 2, 473, 1079, 0, -998, -161], [478, 2, 473, 1079, 0, -998, -161], [2, 1085, 473, 1079, 0, -998, -161], [3340, 2, 473, 1079, 0, -998, -161], [2863, 2, 473, 1079, 0, -998, -161], [2386, 2, 473, 1079, 0, -998, -161], [3341, 1085, 477, 1078, 0, -998, -162], [2, 2168, 477, 1078, 0, -998, -162], [483, 2168, 486, 1078, 0, -991, -162], [973, 2168, 486, 1077, 0, -988, -163], [2, 2, 472, 1079, 0, -998, -161]],
  animations: {
    'Talk Loop': {
      frames: [3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 8, 9, 1, 10, 4, 4, 5, 5, 5, 11, 11, 11, 0, 0, 0, 4, 4, 4, 12, 12, 12, 0, 0, 0, 6, 6, 6, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 11, 11, 11, 0, 0, 4, 4, 4, 5, 5, 5, 0, 0, 0],
      speed: 1
    },
    'Idle Stand': {
      frames: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      speed: 1
    }
  }
};